import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link, useParams } from 'react-router-dom';
import '../css/PrincipalDashboard.css'; // Aap chahein toh common CSS use kar sakte hain
import axios from 'axios';

const Sidebar = () => {
  const userRole = localStorage.getItem('role');
  const userId = localStorage.getItem('userId') || '1';
  const navigate = useNavigate();
  const { id } = useParams(); // URL se :id check karne ke liye
  const location = useLocation();
  
  const dashboardPath = userRole === 'admin' ? '/admin' : `/admin/principal/${userId}`;

  // LOGIC: Agar URL mein koi ID hai, ya state mein viewMode admin hai, aur dekhne wala admin hai, 
  // tabhi pata chalega ki admin kisi aur ka dashboard dekh raha hai.
  const isAdminViewingUser = (id || location.state?.viewMode === "admin") && userRole === "admin";

  return (
    <aside className="sidebar">
      <nav className="nav-menu">
        <Link to={dashboardPath} className="nav-item active" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <span>🏠</span> Dashboard
        </Link>
        <div className="nav-item"><span>🎓</span> My Enrollments</div>
        
        {/* FIX: Return tab sirf tabhi dikhega jab admin kisi aur ka dashboard check kar raha ho */}
        {isAdminViewingUser && (
          <div className="nav-item" onClick={() => navigate('/admin')} style={{ cursor: 'pointer' }}>
            <span>⬅️</span> Return
          </div>
        )}
      </nav>
    </aside>
  );
};

const TeacherDashboard = () => {
  const { state } = useLocation();
  const [userData, setUserData] = useState(state?.user || JSON.parse(localStorage.getItem("user")));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Agar teacher ka subject/department data nahi hai, toh API call karo
    if (!userData || !userData.teacherSubject) {
      fetchFullProfile();
    }
  }, []);

  const fetchFullProfile = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get('https://api.satrixstore.in/api/me', {
        headers: { 
          'Authorization': `Bearer ${token}`
        }
      });
      setUserData(response.data.data);
      localStorage.setItem("user", JSON.stringify(response.data.data));
    } catch (error) {
      console.error("Error fetching teacher profile:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading Teacher Dashboard...</div>;

  const user = userData || {};

  // Student Leads (Sample Data)
  const students = [
    { id: 1, name: 'Rahul Kumar', stream: 'Science (PCM)', course: 'B.Tech (CSE)', status: 'In Progress', location: 'Patna', contact: '+91 98555 43210' },
    { id: 2, name: 'Priya Singh', stream: 'Science (PCB)', course: 'B.Sc. (Biotech)', status: 'New Lead', location: 'Ranchi', contact: '+91 91222 56789' }
  ];

  return (
    <div className="principal-dashboard-root">
      <Sidebar/>
      <div className="principal-dashboard-container">
        <div className="main-content">
          <header className="welcome-header">
            <p>Welcome back, Teacher 👋</p>
            <h1>{user.fullName || "Teacher Name"}</h1>
          </header>

          <div className="profile-hero-card">
            <div className="profile-main">
              <div className="avatar">{user.fullName ? user.fullName.charAt(0) : 'T'}</div>
              <div className="info">
                <h3>{user.fullName || "Teacher Name"}</h3>
                <p><span>📧</span> {user.email || "teacher@evridya.com"}</p>
                <p><span>📱</span> {user.phoneNumber || "+91 98765 43210"}</p>
                <p><span>📍</span> {user.city || "Rohtak"}</p>
              </div>
            </div>
            <div className="stats-grid">
              <div className="stat-item"><span>📚</span><label>Subject:</label> <strong>{user.teacherSubjectTaught || "Physics"}</strong></div>
              <div className="stat-item"><span>🏫</span><label>Current Organization:</label> <strong>{user.teacherCurrentOrganization || "Science"}</strong></div>
              <div className="stat-item"><span>👥</span><label>Exprience:</label> <strong>{user.teacherYearsOfExperience || "150"}</strong></div>
              <div className="stat-item"><span>👥</span><label>My Students:</label> <strong>{user.teacherTotalStudents || "150"}</strong></div>
            </div>
          </div>

          <div className="table-card">
            <div className="table-header">
              <h3>Assigned Student Leads</h3>
              <div className="search-filter">
                <input type="text" placeholder="Search student..." />
              </div>
            </div>
            <table>
              <thead>
                <tr><th>#</th><th>Student Name</th><th>12th Stream</th><th>Interested Course</th><th>Location</th><th>Status</th></tr>
              </thead>
              <tbody>
                {students.map((s, index) => (
                  <tr key={s.id}>
                    <td>{index + 1}</td>
                    <td>
                      <strong>{s.name}</strong><br /><small>{s.contact}</small>
                    </td>
                    <td>{s.stream}</td>
                    <td>{s.course}</td>
                    <td>{s.location}</td>
                    <td>
                      <span className={`status-pill ${s.status.toLowerCase().replace(' ', '-')}`}>{s.status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherDashboard;